// extracted by mini-css-extract-plugin
export default {"window":"WindowTemplate_window__tOnLu","windowBody":"WindowTemplate_windowBody__xx7vu","fullscreen":"WindowTemplate_fullscreen__k1gPq"};